export const isValidPaymentAmount = (value: string) =>
	/^([1-9]{1}([0-9]{1,9})?)([.,]?[0-9]{1,2})?$/.test(value);

export const moneyFormatNoDecimal = (value: number, currencyAddition?: boolean) =>
	currencyAddition
		? Intl.NumberFormat("sv-SE", {
				style: "currency",
				currency: "SEK",
				maximumFractionDigits: 0,
			}).format(value)
		: Intl.NumberFormat("sv-SE", {
				maximumFractionDigits: 0,
			}).format(value);

export const revertFormatNoDecimal = (value: string) => value.replace(/\D/g, "");
// 1234567 to 123-4567, or 12345678 to 1234-5678
export const formatBgNumber = (number: string) => {
	if (!number) {
		return "";
	}

	if (number?.includes("-")) {
		return number.trim();
	}
	return [number.slice(0, number.length - 4), "-", number.slice(number.length - 4)].join("");
};

// from [YYYYMMDD-XXXX] to YYYYMMDDXXXX
export const normalizeSsn = (ssn: string) => {
	const ssnWithoutDash = ssn.replace("-", "");
	return ssnWithoutDash;
};

export const formatSsn = (ssn: string) =>
	ssn && ssn.length === 12 && !ssn.includes("-") ? `${ssn.slice(2, 8)}-${ssn.slice(8)}` : ssn;

export const compareNumbers = (a: number, b: number) => a - b;

export const isInt = (value: string) => {
	if (Number.parseInt(value, 10).toString() === value) {
		return true;
	}
	return false;
};

export const isInteger = (value: number | string) => Number(value) % 1 === 0;

export const isFloat = (value: number | string) => Number(value) % 1 !== 0;
